window.loadYouTubeVideo = function(element) {
   const videoId = element.dataset.videoId;
   const iframe = document.createElement('iframe');
   iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
   iframe.className = 'w-full h-full absolute inset-0';
   iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
   iframe.allowFullscreen = true;
   iframe.title = 'YouTube video player';
   
   element.innerHTML = '';
   element.appendChild(iframe);
   element.style.cursor = 'default';
   element.onclick = null;
};